/**
 * Chaves centralizadas do localStorage.
 * Usar estas constantes em vez de strings hardcoded.
 */
export const STORAGE_KEYS = {
  TOKEN: '@mybank:token',
  USER: '@mybank:user',
  TENANT: '@mybank:tenant',
  THEME: '@mybank:theme',
  ONBOARDING_COMPLETE: '@mybank:onboarding-complete',
  SIDEBAR_COLLAPSED: 'mybank:sidebar-collapsed',
  BLOG_BOOKMARKS: '@mybank:blog-bookmarks',
  TUTORIAL_PREFIX: '@mybank:tutorial-',
};
